import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'scrTime'
})
export class ScrTimePipe implements PipeTransform {

  transform(value: Date | string | number): string | null {
    return formatDate(value, 'h:mm a', navigator.language);
  }
}
